import TimeAgo from "react-timeago";
// import { Trash } from "phosphor-react";
import { Circle, CheckCircle } from "phosphor-react";
import styled from "styled-components";
// import { Draggable } from "react-beautiful-dnd";

function sizeToTitle(size) {
  const sizes = {
    16: 20,
    20: 25,
    24: 30,
    27: 35,
    32: 41,
  };
  return sizes[size];
}

// const Color = styled.div`
//   height: 30px;
//   width: 30px;
//   background: ${({ color }) => color};
//   border-radius: 50%;
// `;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  background: var(--primary);
  border-radius: 3px;
  padding: 20px;
  align-items: center;
  color: white;
  box-shadow: 2px 8px 16px -6px rgb(0 0 0 / 19%);
  margin-bottom: 15px;
`;

const Title = styled.div`
  @media screen and (min-width: 900px) {
    font-size: 25px;
  }
  font-size: 20px;
  color: white;
  font-weight: 900;
  cursor: pointer;
  display: flex;
  width: 30%;
  align-items: center;
  div {
    margin-right: 10px;
  }
  &:hover {
    text-decoration: underline;
  }
`;

const Body = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Item = styled.div`
  display: none;
  align-items: center;
  font-weight: 700;
  padding: 0 10px;
  font-size: 0.7rem;
  justify-content: flex-end;
  &:first-child {
    font-weight: 900;
    font-size: 0.8rem;
  }
  @media screen and (min-width: 900px) {
    display: flex;
  }
`;

const Indicators = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 0.8rem;
`;

const Complete = styled.div`
  @media screen and (min-width: 900px) {
    padding: 7px;
  }
  display: flex;
  align-items: center;
  font-weight: 900;
  font-size: 0.6rem;
  text-transform: uppercase;
  svg {
    padding-left: 7px;
    color: ${({ complete }) => (complete ? "green" : "red")};
  }

  border-radius: 5px;
  padding: 2px 5px;
  margin-right: 5px;
  cursor: ${({ edit }) => (edit ? "pointer" : "unset")};
  background: rgba(247, 246, 241, 0.8);
  color: ${({ complete }) => (complete ? "green" : "red")};
  opacity: ${({ complete }) => (complete ? ".4" : "1")};
  border: 1px dotted
    ${({ edit, complete }) =>
      edit ? (complete ? "green" : "red") : "transparent"};
  &:hover {
    border: 1px solid ${({ edit }) => (edit ? "white" : "transparent")};
  }
`;

// const Button = styled.div`
//   border: 1px solid transparent;
//   padding: 5px;
//   border-radius: 3px;
//   cursor: pointer;
//   &:hover {
//     background: white;
//     color: var(--primary);
//   }
// `;

const ProjectCard = ({
  project,
  handleClick,
  handleDelete,
  index,
  handleEdit,
  edit,
}) => {
  return (
    <Container>
      <Title onClick={() => handleClick(project.id)}>
        <div>
          {project.kitName} {sizeToTitle(project.size)}'
        </div>
      </Title>

      <Body>
        <Item>{project.h / 6 / 12}' walls</Item>
        <Item>
          <TimeAgo date={project.created} />
        </Item>

        {/* <Button onClick={() => handleDelete(project.id)}>
          <Trash />
        </Button> */}

        <Indicators>
          <Complete
            onClick={() =>
              edit
                ? handleEdit(
                    project.id,
                    "drawingComplete",
                    !project.drawingComplete
                  )
                : null
            }
            complete={project.drawingComplete}
            edit={edit}
          >
            Drawing{" "}
            {project.drawingComplete ? (
              <CheckCircle size={25} weight="fill" />
            ) : (
              <Circle size={25} weight="bold" />
            )}
          </Complete>
          <Complete
            onClick={() =>
              edit
                ? handleEdit(
                    project.id,
                    "projectComplete",
                    !project.projectComplete
                  )
                : null
            }
            complete={project.projectComplete}
            edit={edit}
          >
            project{" "}
            {project.projectComplete ? (
              <CheckCircle size={25} weight="fill" />
            ) : (
              <Circle size={25} weight="bold" />
            )}
          </Complete>
          <Complete
            onClick={() =>
              edit
                ? handleEdit(
                    project.id,
                    "windowsComplete",
                    !project.windowsComplete
                  )
                : null
            }
            complete={project.windowsComplete}
            edit={edit}
          >
            windows{" "}
            {project.windowsComplete ? (
              <CheckCircle size={25} weight="fill" />
            ) : (
              <Circle size={25} weight="bold" />
            )}
          </Complete>
        </Indicators>
      </Body>
    </Container>
  );
};

export default ProjectCard;
